module.exports = __webpack_public_path__ + "img/DidotLH-Italic.0f6a2c3f.svg";